import { type Ref, watch } from 'vue';

export default function useScrollToTop(pageRef: Ref<number>) {
  watch(pageRef, () => {
    window.scrollTo({
      behavior: 'instant',
      top: 0,
    });
  });
}
